import React from 'react';
import { Icon, IconNameEnum } from '@jbhi-fi/lanyard-ui/components/Icon';
import { styles } from './InfoCalloutBlock.css';
import { MarkdownBlock } from '../../MarkdownBlock';

export type InfoCalloutBlockProps = {
  flexDirection?: 'column' | 'row';
  subTextColor?: 'default' | 'light';
  features: Array<{ iconName: IconNameEnum | keyof typeof IconNameEnum; description: string; subText?: string }>;
};
export const InfoCalloutBlock = ({
  flexDirection = 'column',
  features,
  subTextColor = 'default',
}: InfoCalloutBlockProps) => {
  return (
    <div className={styles.container({ flexDirection })}>
      {features.map((feature, i) => (
        <div key={i} className={styles.featureContainer}>
          <Icon className={styles.icon} name={feature.iconName} height={16} width={16} />
          <div className={styles.contentContainer}>
            <MarkdownBlock className={styles.descriptionText}>{feature.description}</MarkdownBlock>
            {feature.subText ? <p className={styles.subText({ subTextColor })}>{feature.subText}</p> : null}
          </div>
        </div>
      ))}
    </div>
  );
};
